// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__UJ5Fn","content":"layout_content__Cc91t"};